const status = {
  draft: 'draft',
  active: 'active',
  completed: 'completed',
  canceled: 'canceled'
};

module.exports = status;
